export default {
  methods: {
    goTo (url) {
      this.$router.push(url).catch(err => {
        // Ignore duplicate navigation error
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },
    goToRouteByName (name, params = {}, query = {}) {
      if (this.$route.name === name && JSON.stringify(this.$route.params) === JSON.stringify(params) && JSON.stringify(this.$route.query) === JSON.stringify(query)) {
        return
      }

      this.$router.push({ name: name, params: params, query: query })
    },
    goToNewTab (name, params = {}) {
      const route = this.$router.resolve({ name: name, params: params })
      window.open(route.href, '_blank')
    }
  }
}
